import { appEnv } from "@/constants/app-env";
import mixpanel from "mixpanel-browser";

export enum TrackingEvent {
  SignUp = "Sign Up",
  SignIn = "Sign In",
  SignOut = "Sign Out",
  ChannelAdded = "Channel Added",
  ChannelDeleted = "Channel Deleted",
  UpdatePayoutDetails = "Update Payout Details",
  PlayMusic = "Play Music",
  StopMusic = "Stop Music",
  FavoriteMusic = "Favorite Music",
  UnfavoriteMusic = "Unfavorite Music",
}

export enum NewTrackingEvent {
  // View Landing Page
  ViewLandingPage = "View Landing Page",
  ClickSignUpButton = "Click Sign Up Button",
  ViewSignUpPage = "View Sign Up Page",
  ClickSignInButton = "Click Sign In Button",
  ViewSignInPage = "View Sign In Page",
  ClickGetStartedButton = "Click Get Started Button",

  // Manage Channels
  ViewManageChannelsPage = "View Manage Channels Page",
  ClickAddChannelButton = "Click Add Channel Button",
  ViewAddOptionModal = "View Add Option Modal",
  ClickContinueButtonOfAddOptionModal = "Click Continue Button Of Add Option Modal",
  ViewEnterURLModal = "View Enter URL Modal",
  ViewVerificationCodeModal = "View Verification Code Modal",
  ClickVerifyButtonOfVerificationCodeModal = "Click Verify Button Of Verification Code Modal",
  CompleteChannelVerification = "Complete Channel Verification",

  // Dashboard
  ViewDashboardPageAnalyticsTab = "View Dashboard Page Analytics Tab",
  ViewDashboardPageContentsTab = "View Dashboard Page Contents Tab",
  ViewMusicPageTracksTab = "View Music Page Tracks Tab",
  ViewMusicPageFavoritesTab = "View Music Page Favorites Tab",
  ClickUseMusicButton = "Click Use Music Button",
  CompleteUsingMusic = "Complete Using Music",
  ViewPayoutPageWithdrawTab = "View Payout Page Withdraw Tab",
  RequestWithdraw = "Request Withdraw",
  ViewPayoutPageRevenueTab = "View Payout Page Revenue Tab",

  // Blog
  ClickBlog = "Click Blog",
  ViewBlogListPage = "View Blog List Page",
  ViewBlogContentPage = "View Blog Content Page",

  // Other
  ClickSupport = "Click Support",
  ClickTopPromotionBar = "Click Top Promotion Bar",

  // Campaign Pre-Register
  ViewPreRegisterPage = "View Pre-register Page",
  ClickPreRegisterButton = "Click Pre-register Button",
  CompletePreRegistration = "Complete Pre-registration",

  // Campaign
  ClickCampaign = "Click Campaign",
  ViewCampaignPage = "View Campaign Page",
  ClickCampaignMusicTrack = "Click Campaign Music Track",
  ClickJoinCampaignButton = "Click Join Campaign Button",
  ViewCampaignRegisterPage = "View Campaign Register Page",
  ClickCheckEstimatedViews = "Click Check Estimated Views",
  ViewCampaignRegisterChannel = "View Campaign Register - 1. Channel",
  SelectCampaignChannel = "Select Campaign Channel",
  ViewCampaignRegisterUploadDate = "View Campaign Register - 2. Upload Date",
  SelectCampaignUploadDate = "Select Campaign Upload Date",
  ViewCampaignRegisterReview = "View Campaign Register - 3. Review",
  ViewCampaignRegisterComplete = "View Campaign Register - 4. Complete",
  JoinCampaign = "Join Campaign",
  SubmitCampaignVideoUrl = "Submit Campaign Video URL",
  ClickNewCampaignNotification = "Click New Campaign Notification",
}
interface NewTrackingEventProperties {
  // biome-ignore lint/complexity/noBannedTypes: <explanation>
  [NewTrackingEvent.ViewLandingPage]: {};
  [NewTrackingEvent.ClickSignUpButton]: {
    button_location: string;
    type: "email" | "google";
  };
  // biome-ignore lint/complexity/noBannedTypes: <explanation>
  [NewTrackingEvent.ViewSignUpPage]: {};
  [NewTrackingEvent.ClickSignInButton]: {
    button_location: string;
  };
  // biome-ignore lint/complexity/noBannedTypes: <explanation>
  [NewTrackingEvent.ViewSignInPage]: {};
  // biome-ignore lint/complexity/noBannedTypes: <explanation>
  [NewTrackingEvent.ClickGetStartedButton]: {};
  // biome-ignore lint/complexity/noBannedTypes: <explanation>
  [NewTrackingEvent.ViewManageChannelsPage]: {};
  // biome-ignore lint/complexity/noBannedTypes: <explanation>
  [NewTrackingEvent.ClickAddChannelButton]: {};
  // biome-ignore lint/complexity/noBannedTypes: <explanation>
  [NewTrackingEvent.ViewAddOptionModal]: {};
  [NewTrackingEvent.ClickContinueButtonOfAddOptionModal]: {
    register_options: "google account" | "channel URL";
  };
  // biome-ignore lint/complexity/noBannedTypes: <explanation>
  [NewTrackingEvent.ViewEnterURLModal]: {};
  // biome-ignore lint/complexity/noBannedTypes: <explanation>
  [NewTrackingEvent.ViewVerificationCodeModal]: {};
  [NewTrackingEvent.ClickVerifyButtonOfVerificationCodeModal]: {
    verification_success: boolean;
  };
  [NewTrackingEvent.CompleteChannelVerification]: {
    channel_handle: string;
    register_options: "google account" | "channel URL";
  };
  // biome-ignore lint/complexity/noBannedTypes: <explanation>
  [NewTrackingEvent.ViewDashboardPageAnalyticsTab]: {};
  // biome-ignore lint/complexity/noBannedTypes: <explanation>
  [NewTrackingEvent.ViewDashboardPageContentsTab]: {};
  // biome-ignore lint/complexity/noBannedTypes: <explanation>
  [NewTrackingEvent.ViewMusicPageTracksTab]: {};
  // biome-ignore lint/complexity/noBannedTypes: <explanation>
  [NewTrackingEvent.ViewMusicPageFavoritesTab]: {};
  // biome-ignore lint/complexity/noBannedTypes: <explanation>
  [NewTrackingEvent.ClickUseMusicButton]: {};
  // biome-ignore lint/complexity/noBannedTypes: <explanation>
  [NewTrackingEvent.CompleteUsingMusic]: {};
  // biome-ignore lint/complexity/noBannedTypes: <explanation>
  [NewTrackingEvent.ViewPayoutPageWithdrawTab]: {};
  [NewTrackingEvent.RequestWithdraw]: {
    balance: number;
  };
  // biome-ignore lint/complexity/noBannedTypes: <explanation>
  [NewTrackingEvent.ViewPayoutPageRevenueTab]: {};
  [NewTrackingEvent.ClickBlog]: {
    button_location: string;
  };
  // biome-ignore lint/complexity/noBannedTypes: <explanation>
  [NewTrackingEvent.ViewBlogListPage]: {};
  [NewTrackingEvent.ViewBlogContentPage]: {
    blog_content_number: number;
    blog_content_subject: string;
  };
  [NewTrackingEvent.ClickSupport]: {
    button_location: string;
  };
  [NewTrackingEvent.ClickTopPromotionBar]: {
    promotion_name: string;
    promotion_number: number;
  };
  // biome-ignore lint/complexity/noBannedTypes: <explanation>
  [NewTrackingEvent.ViewPreRegisterPage]: {};
  [NewTrackingEvent.ClickPreRegisterButton]: {
    button_location: string;
  };
  [NewTrackingEvent.CompletePreRegistration]: {
    email: string;
    channel_url: string;
  };
  [NewTrackingEvent.ClickCampaign]: {
    button_location: string;
    campaign_id: string;
  };
  [NewTrackingEvent.ViewCampaignPage]: {
    campaign_id: string;
    campaign_title: string;
  };
  [NewTrackingEvent.ClickCampaignMusicTrack]: {
    campaign_id: string;
    isrc: string;
  };
  [NewTrackingEvent.ClickJoinCampaignButton]: {
    button_location: string;
    campaign_id: string;
  };
  [NewTrackingEvent.ViewCampaignRegisterPage]: {
    campaign_id: string;
  };
  [NewTrackingEvent.SelectCampaignChannel]: {
    campaign_id: string;
    channel_id: string;
  };
  [NewTrackingEvent.ClickCheckEstimatedViews]: {
    campaign_id: string;
    channel_id: string;
  };
  [NewTrackingEvent.ViewCampaignRegisterChannel]: {
    campaign_id: string;
  };
  [NewTrackingEvent.ViewCampaignRegisterUploadDate]: {
    campaign_id: string;
  };
  [NewTrackingEvent.SelectCampaignUploadDate]: {
    campaign_id: string;
    upload_date: string;
  };
  [NewTrackingEvent.ViewCampaignRegisterReview]: {
    campaign_id: string;
  };
  [NewTrackingEvent.ViewCampaignRegisterComplete]: {
    campaign_id: string;
  };
  [NewTrackingEvent.JoinCampaign]: {
    campaign_id: string;
  };
  [NewTrackingEvent.ClickNewCampaignNotification]: {
    button_location: "top" | "bottom";
    campaign_id: string;
  };
  [NewTrackingEvent.SubmitCampaignVideoUrl]: {
    campaign_id: string;
    video_url: string;
  };
}

export function trackNewEvent<T extends NewTrackingEvent>(event: T, properties: NewTrackingEventProperties[T]) {
  if (appEnv.isDevelopment) {
    console.log(event, properties);
    return;
  }
  // @ts-ignore
  if (mixpanel.__loaded) {
    mixpanel.track(event, properties);
  }
}

export function trackEvent(event: TrackingEvent, data: Record<string, unknown>) {
  // @ts-ignore
  if (mixpanel.__loaded) {
    mixpanel.track(event, data);
  }

  if (appEnv.isDevelopment) {
    console.log(event, data);
  }
}
